export const selectSummaryData = (state) => state.testingAnalyticsSummary?.summaryData;
export const selectLoading = (state) => state.testingAnalyticsSummary?.loading;
export const selectError = (state) => state.testingAnalyticsSummary?.error;